import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyles = css`
  width: 100%;
  min-height: 100%;
  background-color: ${theme.colors.neutral5};
  padding: ${theme.spacing(4)};
`;

export const cardStyles = css`
  width: min(100%, 750px);
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.light};
  padding: ${theme.spacing(4)};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const descriptionStyles = css`
  margin-top: ${theme.spacing(4)};
`;

export const headingStyles = css`
  margin-bottom: ${theme.spacing(4)};
`;

export const svgStyles = css`
  width: max(55%, 200px);
`;
